/**
 * Default error handler
 *
 * @throws Error
 * @public
 */
const defaultErrorHandler = (err) => {
    throw new Error(err);
};
const lazy = async function lazy(module, handler, errorHandler) {
    try {
        const { default: request } = await module;
        return await handler(request);
    }
    catch (err) {
        const handle = errorHandler ? errorHandler : defaultErrorHandler;
        handle(err);
    }
};
export default lazy;
//# sourceMappingURL=lazy.js.map